import { Button } from '@/components/shadcn/button'
import { IconV2DownloadOutline } from '@icons/IconV2DownloadOutline'

export function DownloadTemplateButton({
  updatedText,
  onClick,
  disabled,
}: {
  updatedText: string
  onClick: () => void
  disabled: boolean
}) {
  return (
    <div className="flex w-full justify-end">
      <div className="flex flex-col items-center gap-1">
        <Button variant="outline" size="sm" onClick={onClick} disabled={disabled}>
          <IconV2DownloadOutline className="mr-2 size-4" />
          Download template
        </Button>
        <div className="text-xs text-muted-foreground">{updatedText}</div>
      </div>
    </div>
  )
}
